/* eslint-disable no-console */
import { delay } from 'redux-saga';
import { put, takeLatest, select, call } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { notification } from 'antd';
import { searchElementMatch, setNotification, locales } from 'utils';
import * as CarrierActions from '../actions/carrierActions';
import * as CarrierApi from '../api/carrierApi';
import * as CarrierTypes from '../types/carrierTypes';

const getCarrier = state => state.carrier;
const getLayout = state => state.layout;

// A D D   N E W   C A R R I E R
function* addPropertyToCarrier(data) {
    yield CarrierApi.addPropertyToCarrierApi(data);
}

function* deletePropertyToCarrier(data) {
    yield CarrierApi.deletePropertyToCarrierApi(data);
}

function* updateCarrierTranslateSaga(action) {
    const { locale } = yield select(getLayout);

    const data = {
        carrier_id: action.data.carrier_id,
        reseller_id: action.data.reseller_id,
    };

    const params = { bulk: [] };
    locales.forEach((lc) => {
        if (lc !== 'en' || (lc === 'en' && action.type === CarrierTypes.EDIT_CARRIER)) {
            params.bulk.push({
                ...action.data[lc],
                ...data,
            });
        }
    });

    const result = yield CarrierApi.updateCarrierTranslateApi(params);

    if (result.status !== 202) {
        const error = yield result.json();
        setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
    }
}

function* addNewCarrierSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const finalDescription = 'carrier.notification.newCarrierAddedSuccess';

    try {
        const data = {
            carrier_id: action.data.carrier_id,
            reseller_id: action.data.reseller_id,
            ...action.data.en,
        };
        const result = yield CarrierApi.addNewCarrierApi(data);

        if (result.status === 202) {
            yield put(CarrierActions.addNewCarrierRes(true, false));
            yield call(updateCarrierTranslateSaga, action);

            if (action.data.properties && action.data.properties.length > 0) {
                const { properties } = action.data;

                const attachParams = { bulk: [] };

                for (let i = 0; i < properties.length; i += 1) {
                    attachParams.bulk.push({
                        carrier_id: data.carrier_id,
                        property_id: properties[i],
                    });
                }

                yield call(addPropertyToCarrier, attachParams);
            }

            yield put(push('/factory/carriers/'));

            yield put(CarrierActions.addNewCarrierRes(false, true));
            yield delay(1000);
            yield put(CarrierActions.addNewCarrierRes(false, false));

            setNotification('success', locale, 'global.success', finalDescription);
        } else {
            const error = yield result.json();

            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(CarrierActions.addNewCarrierErr(error.message));
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'carrier.notification.loadCarriersWithPropertyError');
        yield put(CarrierActions.addNewCarrierErr());
        console.log(e);
    }
}

export function* addCarrierWatcher() {
    yield takeLatest(CarrierTypes.ADD_NEW_CARRIER, addNewCarrierSaga);
}
// A D D   N E W   C A R R I E R


// L O A D   E D I T A B L E   C A R R I E S
function* loadEditableCarrierSaga(action) {
    try {
        const paramProperty = {
            filter: JSON.stringify({
                id: action.id,
            }),
            joins: JSON.stringify(['property']),
        };

        const resultCarrier = yield CarrierApi.getCarriersApi(paramProperty);

        if (resultCarrier.data.hits.length === 0) {
            notification.error({
                message: 'Error',
                description: 'Carrier don\'t exist',
            });

            yield put(push('/404'));
            yield put(CarrierActions.loadCarriersErr());
        } else {
            yield put(CarrierActions.loadEditableCarrierRes(resultCarrier.data.hits[0]));
        }
    } catch (e) {
        yield put(CarrierActions.loadCarriersErr());
        console.log(e);
    }
}

export function* loadEditableCarrierWatcher() {
    yield takeLatest(CarrierTypes.LOAD_EDITABLE_CARRIER, loadEditableCarrierSaga);
}
// L O A D   E D I T A B L E   C A R R I E S


// E D I T   C A R R I E S
function* editTableCarrierSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    try {
        // const result = yield editCarrierApi(action.data);

        yield call(updateCarrierTranslateSaga, action);

        const { newProperties, deletedProperties } = action.data;

        if (newProperties.length > 0) {
            const attachParams = { bulk: [] };

            for (let i = 0; i < newProperties.length; i += 1) {
                attachParams.bulk.push({
                    carrier_id: action.data.carrier_id,
                    property_id: newProperties[i],
                });
            }

            yield call(addPropertyToCarrier, attachParams);
            yield delay(300);
        }

        if (deletedProperties.length > 0) {
            const detachParams = { bulk: [] };

            for (let i = 0; i < deletedProperties.length; i += 1) {
                detachParams.bulk.push({
                    carrier_id: action.data.carrier_id,
                    property_id: deletedProperties[i],
                });
            }

            yield call(deletePropertyToCarrier, detachParams);
            yield delay(300);
        }

        yield put(push('/factory/carriers/'));
        yield put(CarrierActions.editCarrierRes(true, true));
        yield delay(1000);
        yield put(CarrierActions.editCarrierRes(false, false));
    } catch (e) {
        yield put(CarrierActions.editCarrierErr());
        setNotification('error', locale, 'global.error', 'carrier.notification.loadCarriersWithPropertyError');
        console.log(e);
    }
}

export function* editCarrierWatcher() {
    yield takeLatest(CarrierTypes.EDIT_CARRIER, editTableCarrierSaga);
}
// E D I T   C A R R I E S


// L O A D   C A R R I E R S
function* loadCarriersSaga() {
    try {
        const carrier = yield select(getCarrier);
        const layout = yield select(getLayout);

        const { offset, limit } = carrier;
        const { locale } = layout;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['property']),
        };

        if (carrier.sort !== null) {
            const sortInt = carrier.sort.type === 'asc' ? 1 : -1;

            if (carrier.sort.key === 'name') {
                params.sort_by = JSON.stringify({ unique_name: sortInt });
            } else if (carrier.sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            }
        }

        if (carrier.filters.name !== '') {
            params.filter = JSON.stringify({
                name: searchElementMatch(carrier.filters.name, locale),
            });
        }

        const result = yield CarrierApi.getCarriersApi(params);
        yield put(CarrierActions.loadCarriersRes(result.data));
    } catch (e) {
        yield put(CarrierActions.loadCarriersErr());
        console.log(e);
    }
}

export function* loadCarriersWatcher() {
    yield takeLatest(CarrierTypes.LOAD_CARRIERS, loadCarriersSaga);
}
// L O A D   C A R R I E R S


// F I L T E R   C A R R I E R S
function* setCarrierFiltersSaga(action) {
    try {
        const carrier = yield select(getCarrier);
        const layout = yield select(getLayout);

        const { offset, limit } = carrier;
        const { locale } = layout;

        const params = {
            offset,
            limit,
            filter: JSON.stringify({
                [action.key]: searchElementMatch(action.value, locale),
            }),
            joins: JSON.stringify(['property']),
        };

        if (carrier.sort !== null) {
            params.sort_by = JSON.stringify({ unique_name: carrier.sort.type === 'asc' ? 1 : -1 });
        }

        const result = yield CarrierApi.getCarriersApi(params);
        yield put(CarrierActions.setCarrierFiltersRes(result.data));
        yield call(delay, 500);
    } catch (e) {
        yield put(CarrierActions.loadCarriersErr());
        console.log(e);
    }
}

export function* setCarriersFilterWatcher() {
    yield takeLatest(CarrierTypes.SET_CARRIER_FILTER, setCarrierFiltersSaga);
}
// F I L T E R   C A R R I E R S
